const navigation = [
  // {
  //   id: "home",
  //   label: "Главная",
  //   href: "/",
  // },
  {
    id: "Stocks",
    label: "Акции",
    href: "#offers",
  },
  {
    id: "Services",
    label: "Услуги",
    href: "#",
  },
  {
    id: "Information",
    label: "Полезная Информация",
    href: "#faq",
  },
  {
    id: "Contacts",
    label: "Контакты",
    href: "#footer",
  },

  /* ===== Образец если нужно древовидное меню на сайте ===== */
  
  // {
  //   id: "fuel",
  //   label: "Топливо",
  //   href: "/test",
  //   children: [
  //     { 
  //       id: "diesel",
  //       label: "Дизель",
  //       href: "#diesel",
  //       children: [
  //         { id: "diesel-1", label: "Евро-5", href: "#euro5" },
  //         { id: "diesel-2", label: "Арктика", href: "#arktika" },
  //       ],
  //      },
  //   ],
  // },
  // {
  //   id: "delivery",
  //   label: "Доставка",
  //   href: "#delivery",
  //   children: [
  //     { id: "moscow", label: "Москва", href: "#moscow" },
  //     { id: "region", label: "Область", href: "#region" },
  //   ],
  // },
  // {
  //   id: "contacts",
  //   label: "Контакты",
  //   href: "#contacts",
  // },
];

export default navigation;
